import { isString } from 'lodash'
import { sniff } from '@/util'

const setWebviewAttr = function (config = '') {
  const jsonStr = isString(config) ? config :  JSON.stringify(config)
  if (sniff.isUboxAndroidApp) {
    window.app?.setWebviewAttr && window.app?.setWebviewAttr(jsonStr)
  } else if (sniff.isUboxIosApp) {
    window.webkit?.messageHandlers?.setWebviewAttr && window.webkit?.messageHandlers.setWebviewAttr.postMessage(jsonStr)
  }
}

export default setWebviewAttr